import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Dropdown, Spinner } from 'react-bootstrap';
import Select from "react-select";

//Import
import { ThemeContext } from "../../../context/ThemeContext";
import BestSellingTab from '../Ventic/Home/Tab/BestSellingTab';
import RecentEvenList from '../Ventic/Home/RecentEvenList';
import Latestsaleblog from '../Ventic/Home/Latestsaleblog';
import SalesRevenueTab from '../Ventic/Home/Revenue/SalesRevenueTab';
import UpcomingEventSection from '../Ventic/Home/UpcomingEventSection';
import { ReactComponent as RefreshIcon } from "../../../icons/abhi-icons/Frame.svg";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from 'moment';
import { useSelector } from 'react-redux';
import AudienceEngagementChart from '../Ventic/Home/Revenue/AudienceEngagementChart';
import AudienceCounts from '../Ventic/Home/Revenue/AudienceCounts';
import ProjectCounts from '../Ventic/Home/Revenue/ProjectCounts';


const TicketsLineApex = loadable(() =>
    pMinDelay(import("../Ventic/Home/TicketsLineApex"), 1000)
);
const RevenueLineApex = loadable(() =>
    pMinDelay(import("../Ventic/Home/RevenueLineApex"), 1000)
);
const SalesCanvas = loadable(() =>
    pMinDelay(import("../Ventic/Home/LiveFootStepsCanvas"), 1000)
);
const Donut = loadable(() =>
    pMinDelay(import("../Ventic/Home/Donut"), 1000)
);

const DashboardUI = ({ reportData, refreshData, filters, onFilterChange, filterLoading = false }) => {
    const { data: artForms } = useSelector((state) => state['category']);
    const { data: venues } = useSelector((state) => state['venue']);
    const handleDateChange = (start, end) => {
        onFilterChange({
            ...filters,
            startDate: start.format("YYYY-MM-DD"),
            endDate: end.format("YYYY-MM-DD"),
        });
    };

    const handleArtFormChange = (value) => {
        onFilterChange({
            ...filters,
            artForms: value,
        });
    };

    const handleYearChange = (value) => {
        onFilterChange({
            ...filters,
            year: value,
        });
    };

    const handleVenueChange = (value) => {
        onFilterChange({
            ...filters,
            venue: value,
        });
    };

    const { changeBackground, background } = useContext(ThemeContext);
    useEffect(() => {
        changeBackground({ value: "light", label: "Light" });
    }, []);

    const [totalFootFall, settotalFootFall] = useState(0);
    const [stats, setStats] = useState({
        venue_counts: {
            data: [],
            total: 0
        },
        users_counts: {
            data: [],
            total: 0
        },
        live_shows: {
            data: [],
            total: 0,
        },
        upcomming_events: [],
        initiative_wise_count: [],
        total_registration: 0,
        live_foot_count: [],
        live_foot_count_in_artform: [],
        project_counts: [],
        audience_registration_trend: {},
    });

    useEffect(() => {
        settotalFootFall(reportData?.live_foot_count_in_artform.reduce((sum, item) => sum + item.totalCount, 0));
        setStats({
            venue_counts: {
                data: reportData?.venue_counts ?? [],
                total: reportData?.venue_counts?.length ?? 0,
            },
            users_counts: {
                data: reportData?.users_count ?? [],
                total: reportData?.users_count.reduce((sum, item) => sum + item.count, 0)
            },
            live_shows: {
                data: (reportData?.shows ?? []).reduce((x, item) => [...x, ...item.schedules], []),
                total: 0
            },
            upcomming_events: reportData?.upcoming_events ?? [],
            initiative_wise_count: reportData?.initiative_wise_count ?? [],
            total_registration: reportData?.total_registration || 0,
            live_foot_count: reportData?.live_foot_count,
            live_foot_count_in_artform: reportData?.live_foot_count_in_artform || [],
            project_counts: reportData?.project_counts || [],
            audience_registration_trend: reportData?.audience_registration_trend || {},
        });
    }, [reportData]);

    const dateRangeLabel = `${moment(filters.startDate).format("DD-MM-YYYY")} - ${moment(filters.endDate).format("DD-MM-YYYY")}`;

    return (
        <div className='container-mxw' style={{ position: 'relative' }}>
            {filterLoading && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        pointerEvents: 'auto',
                    }}
                >
                    <Spinner animation="border" role="status" style={{ width: '3rem', height: '3rem', color: '#fff', marginBottom: '1rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p style={{ color: '#fff', fontSize: '1.1rem', fontWeight: '500', margin: 0}}>
                        Loading data based on your preference. Please wait...
                    </p>
                </div>
            )}
            <div className="form-head mb-4 d-flex flex-wrap align-items-center">
                <div className="me-auto">
                    <h2 className="font-w600 mb-0">Dashboard</h2>
                </div>

            </div>

            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-4 col-xxl-4 col-sm-4 ">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="w-100">
                                        <div className='d-flex justify-content-between'>
                                            <h2 className="text-black font-w500 mb-0">Live Footfall</h2>
                                            <div onClick={refreshData} className='cursor-pointer'>
                                                <RefreshIcon />
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <h1 className=" fw-bold text-primary mb-0">{totalFootFall}</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body h-100 pt-0">
                                    {/* <SalesCanvas totalFootFall={totalFootFall} live_foot_count={stats?.live_foot_count} /> */}
                                    <div
                                        id="widgetChart1"
                                        className="chart-primary d-flex flex-column h-100"
                                    >
                                        {/* Scrollable list container */}
                                        <div className="flex-grow-1 overflow-auto pt-3">
                                            <div>
                                                {stats?.live_foot_count_in_artform?.map((data, index) => (
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>{data?.artForm}</h4>
                                                        <h4 className="fw-bold text-primary">{data?.totalCount}</h4>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {reportData?.initiative_wise_count && reportData?.initiative_wise_count.length > 0 ? reportData?.initiative_wise_count.map((initiativeData, index) => (
                            <div className="col-xl-4 col-xxl-4 col-sm-4 ">
                                <div className="card">
                                    <div className="card-header border-0 pb-0">
                                        <div>
                                            <h2 className="text-black font-w500 mb-0">{initiativeData?.initiative?.title}{" "}{initiativeData?.initiative?.edition}</h2>
                                        </div>
                                    </div>
                                    <div className="card-body h-100 pt-0">
                                        <div
                                            id="widgetChart1"
                                            className="chart-primary d-flex flex-column h-100"
                                        >
                                            {/* Scrollable list container */}
                                            <div className="flex-grow-1 overflow-auto pt-3">
                                                <div>
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>Total Footfall</h4>
                                                        <h4 className="fw-bold text-primary">{initiativeData?.totalFootfall}</h4>
                                                    </div>
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>Total Visitors</h4>
                                                        <h4 className="fw-bold text-primary">{initiativeData?.totalVisitors}</h4>
                                                    </div>
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>Total Registration</h4>
                                                        <h4 className="fw-bold text-primary">{reportData.total_registration}</h4>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total block outside scrollable area, fixed at bottom */}
                                            {/* <div className="border-top mt-2 pt-2 d-flex justify-content-between">
                                                <h4>Total Active Venues</h4>
                                                <h4 className="fw-bold text-primary">{stats?.venue_counts?.total}</h4>
                                            </div> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )) : null}
                        <div className="col-xl-4 col-xxl-4 col-sm-4 ">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="w-100">
                                        <div className='d-flex justify-content-between'>
                                            <h2 className="text-black font-w500 mb-0">Venues</h2>
                                            {/* <div onClick={refreshData} className='cursor-pointer'>
                                                <RefreshIcon />
                                            </div> */}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <h1 className=" fw-bold text-primary mb-0">{stats?.venue_counts?.total}</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body h-100 pt-0">
                                    <div
                                        id="widgetChart1"
                                        className="chart-primary d-flex flex-column h-100"
                                    >
                                        {/* Scrollable list container */}
                                        <div className="flex-grow-1 overflow-auto pt-3">
                                            <div>
                                                {stats?.venue_counts?.data?.map((data, index) => (
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>{data?.venue}</h4>
                                                        <h4 className="fw-bold text-primary">{data?.totalCrowdIn}</h4>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Total block outside scrollable area, fixed at bottom */}
                                        {/* <div className="border-top mt-2 pt-2 d-flex justify-content-between">
                                            <h4>Total Active Venues</h4>
                                            <h4 className="fw-bold text-primary">{stats?.venue_counts?.total}</h4>
                                        </div> */}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-xl-4 col-xxl-4 col-sm-4 ">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div>
                                        <h2 className="text-black font-w500 mb-0">Team</h2>
                                    </div>
                                </div>
                                <div className="card-body h-100 pt-0">
                                    <div
                                        id="widgetChart1"
                                        className="chart-primary d-flex flex-column h-100"
                                    >
                                        {/* Scrollable list container */}
                                        <div className="flex-grow-1 overflow-auto pt-3">
                                            <div>
                                                {stats?.users_counts?.data?.map((data, index) => (
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between mb-2"
                                                    >
                                                        <h4>{data?.title}</h4>
                                                        <h4 className="fw-bold text-primary">{data?.count}</h4>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Total block outside scrollable area, fixed at bottom */}
                                        {/* <div className="border-top mt-2 pt-2 d-flex justify-content-between">
                                            <h4>Total Team Members</h4>
                                            <h4 className="fw-bold text-primary">{stats?.users_counts?.total}</h4>
                                        </div> */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-12 mb-2'>
                    <div className='d-flex gap-3 align-items-center justify-content-end mb-4'>
                        <div className='d-flex align-items-center gap-3'>
                            <b>Filters:</b>
                            <Select
                                value={{
                                    label: filters.artForms ? artForms.find((v) => v._id === filters.artForms)?.name : 'All',
                                    value: filters.artForms ?? "",
                                }}
                                onChange={(e) => {
                                    handleArtFormChange(e.value);
                                }}
                                options={[
                                    { label: 'All', value: '' },
                                    ...artForms.map((art) => ({ label: art.name, value: art._id }))
                                ]}
                                name={'artForm'}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minWidth: '200px',
                                        textAlign: 'left',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        textAlign: 'left',
                                    }),
                                }}
                                style={{
                                    color: "#7e7e7e",
                                    paddingLeft: " 15px",
                                }}
                                classNames={{
                                    control: (state) => "form-control p-0 select-custom-css", // add your class here
                                }}
                            />
                        </div>
                        <div>
                            <Select
                                value={{
                                    label: filters.venue ? venues.find((v) => v._id === filters.venue)?.title : 'All',
                                    value: filters.venue ?? "",
                                }}
                                onChange={(e) => {
                                    handleVenueChange(e.value);
                                }}
                                options={[
                                    { label: 'All', value: '' },
                                    ...venues.map((venue) => ({ label: venue.title, value: venue._id }))
                                ]}
                                name={'venues'}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minWidth: '200px',
                                        textAlign: 'left',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        textAlign: 'left',
                                    }),
                                }}
                                style={{
                                    color: "#7e7e7e",
                                    paddingLeft: " 15px",
                                }}
                                classNames={{
                                    control: (state) => "form-control p-0 select-custom-css", // add your class here
                                }}
                            />
                        </div>
                        <div className="flex-shrink-0 dashboard-filter-daterange">
                            <DateRangePicker
                                initialSettings={{
                                    startDate: moment(filters.startDate, "MM/DD/YYYY"),
                                    endDate: moment(filters.endDate, "MM/DD/YYYY"),
                                    locale: { format: "DD-MM-YYYY" }
                                }}
                                onCallback={handleDateChange}
                            >
                                <input
                                    type="text"
                                    value={dateRangeLabel}
                                    className="form-control input-daterange-timepicker"
                                    style={{
                                        width: `max(100%, calc(${dateRangeLabel.length + 1}ch + 0.5rem))`,
                                    }}
                                />
                            </DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='col-xl-12 col-xxl-12'>
                    <AudienceEngagementChart chartData={stats.audience_registration_trend} />
                </div>
                <div className="col-xl-6 col-xxl-6">
                    <div className="row">
                        <div className="col-xl-12">
                            <RecentEvenList eventlist={stats?.live_shows?.data} total={stats?.live_shows?.total} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-xxl-6">
                    <div className="row">
                        <div className="col-xl-12">
                            <AudienceCounts data={stats?.live_foot_count} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-xxl-6">
                    <div className="row">
                        <div className="col-xl-12">
                            <ProjectCounts data={stats?.project_counts} handleYearChange={handleYearChange} filters={filters} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-xxl-6">
                    <div className="row">
                        <div className="col-xl-12">
                            <UpcomingEventSection events={stats?.upcomming_events} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DashboardUI;